import cn from 'classnames';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { highlightC, item, linkActive, nShown, open, root, tag } from './NavDropdown.module.scss';

const NavDropdown = ({ isOpen, notificationIsShown, data, className }) => (
  <ul
    className={cn(root, className, {
      [open]: isOpen,
      [nShown]: notificationIsShown
    })}
  >
    {data.map((value, i) => (
      <li key={i} className={cn({ [highlightC]: value.highlight})}>
        {value.highlight && <span className={tag}></span>}
        <Link
          to={value.link}
          activeClassName={linkActive}
          className={item}
        >{value.text}</Link>
      </li>
    ))}
  </ul>
);
NavDropdown.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  notificationIsShown: PropTypes.bool.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    link: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    highlight: PropTypes.bool,
  })),
  className: PropTypes.string,
};
NavDropdown.defaultProps = {
  isOpen: false,
  notificationIsShown: false,
  data: []
};

export default NavDropdown;
